/**
 * Implements a generic chart interfaces
 */
// import { IOrder } from "../../helpers/tradingModes"
// import { marketsForCurrentExchange } from "../../selectors"

import { IStore } from '../../reducers';

export interface IChartProps {
  symbolId: number;
  chain: string;
  exchange?: string;
  base: string;
  quote: string;
  address: string;
  base_address: string;
  quote_address: string;
  base_decimals: number;
  quote_decimals: number;
  mode: string;
  orders: any;
  width: number;
  height: number;
  pricePrecision: number;
  markets: any;
  actionCancelOrders: Function;
  actionShowModal?: Function;
  isMobile: boolean;
  actionSwitchCurrent: (val: any) => void;
  /**
   * Lightchart props
   */
  datafeed?: any;
  options?: any;
  symbolName?: string;
  onExchangeChange?: any;
  maxWidth?: number;
  maxHeight?: number;
  flipped: boolean;
  onChartClick?: () => void;
}

/**
 * Filters orders
 * @param exchange
 * @param mode
 * @param orders
 */
export const chartFilterOrders = (
  exchange: string,
  base: string,
  quote: string,
  mode: string,
  orders: any
): any[] => {
  const collection = mode === 'margin' ? orders.margin : orders.spot;
  const symbol = quote ? `${base}/${quote}` : base;
  return collection.filter(
    (order: any) =>
      order.exchange === exchange &&
      order.symbol === symbol &&
      ['active', 'open'].includes(order.status)
  );
};

/**
 * 0.001 => 3
 * @param inv
 */
// const reversePrecision = (inv: number) =>
//     inv.toString().split('.')[1].length

export const chartMapStateToProps = (state: IStore) => {
  const [base, quote] = state.current.name.split('/');
  return {
    chain: state.current.chain,
    exchange: state.current.exchange,
    base: base || 'TOKEN',
    quote: quote || 'TOKEN',
    base_address: state.current.base_address,
    quote_address: state.current.quote_address,
    base_decimals: state.current.base_decimals,
    quote_decimals: state.current.quote_decimals,
    address: state.current.address,
    pricePrecision: state.current.base_precision || 2,
    flipped: state.current.flipped,
  };
};
